import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { BaseTipsComponent } from '../base-tips/base-tips.component';
import { TipsComponent } from '../tips.component';

@Component({
  selector: 'app-warn-tips',
  imports: [CommonModule, TipsComponent],
  templateUrl: '../base-tips/base-tips.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['../base-tips/base-tips.component.scss'],
})
export class WarningTipsComponent extends BaseTipsComponent {
  override txtColor: string = 'black';
  override matIcon: string = 'warning';
  override cssColor: string = '--warn-color';
  constructor() {
    super();
  }
}
